import React, { useState } from 'react';
import { toast } from 'sonner';

// Per-video CTA in Studio: submit a published video for Featured review (manual
// quality gate). Shows current state (not submitted / pending / approved /
// rejected) so creators understand where they are in the pipeline.
export const FeaturedSubmit = ({ video, axiosInstance, onUpdated }) => {
  const [submitting, setSubmitting] = useState(false);
  const status = video.review_status || 'not_submitted';
  const featured = !!video.featured;

  const submit = async () => {
    setSubmitting(true);
    try {
      await axiosInstance.post(`/videos/${video.id}/submit-featured`);
      toast.success('Submitted for Featured review');
      if (onUpdated) onUpdated();
    } catch {
      toast.error('Could not submit. Try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (video.status !== 'approved') {
    return null; // only published videos can be submitted
  }

  return (
    <div
      className="px-4 py-2 border-t border-zinc-800 flex items-center justify-between gap-2"
      data-testid={`featured-submit-${video.id}`}
    >
      <div className="text-[11px] min-w-0">
        {featured ? (
          <span className="text-fuchsia-300 font-semibold">★ Featured on marquee</span>
        ) : status === 'approved' ? (
          <span className="text-fuchsia-300">★ Approved — featured</span>
        ) : status === 'pending' ? (
          <span className="text-amber-300">Awaiting review…</span>
        ) : status === 'rejected' ? (
          <span className="text-zinc-400 truncate block">
            Not featured: {video.rejection_reason || 'declined'}
          </span>
        ) : (
          <span className="text-zinc-500">Want a marquee spot?</span>
        )}
      </div>
      {!featured && (status === 'not_submitted' || status === 'rejected') && (
        <button
          onClick={submit}
          disabled={submitting}
          className="text-[11px] font-semibold bg-fuchsia-500/20 hover:bg-fuchsia-500/30 text-fuchsia-200 px-3 py-1 rounded-full disabled:opacity-60"
          data-testid={`featured-submit-btn-${video.id}`}
        >
          {submitting ? 'Submitting…' : status === 'rejected' ? 'Resubmit' : 'Submit for Featured'}
        </button>
      )}
    </div>
  );
};
